module.exports = __webpack_public_path__ + "img/IMG_9701_L.cfc1ac8b.webp";